"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var styled_1 = require("./styled");

var Spinner = styled_components_1.default(function (_a) {
  var size = _a.size,
      props = tslib_1.__rest(_a, ["size"]);

  return react_1.default.createElement("div", tslib_1.__assign({}, props));
})(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), styled_1.spinnerStyle);
Spinner.defaultProps = {
  size: 'md'
};
exports.default = Spinner;
var templateObject_1;